import { useEffect, useState } from 'react';
import { getToken, isTokenExpired } from '@/features/auth/utils/auth';

interface AuthDebugInfo {
  hasToken: boolean;
  isExpired: boolean;
  tokenPreview: string | null;
  lastChecked: Date;
}

export const useAuthDebug = () => {
  const [debugInfo, setDebugInfo] = useState<AuthDebugInfo>({
    hasToken: false,
    isExpired: false,
    tokenPreview: null,
    lastChecked: new Date()
  });

  const checkAuthStatus = () => {
    const token = getToken();
    const expired = isTokenExpired();
    
    setDebugInfo({
      hasToken: !!token,
      isExpired: expired,
      tokenPreview: token ? `${token.substring(0, 20)}...` : null,
      lastChecked: new Date()
    });

    // Debug logging
    console.group('🔍 Authentication Debug');
    console.log('Token available:', !!token);
    console.log('Token expired:', expired);
    if (token) {
      console.log('Token preview:', token.substring(0, 20) + '...');
    }
    console.groupEnd();
  };

  useEffect(() => {
    checkAuthStatus();
    
    // Verificar cada 30 segundos
    const interval = setInterval(checkAuthStatus, 30000);
    
    return () => clearInterval(interval);
  }, []);

  return {
    debugInfo,
    checkAuthStatus
  };
}; 